<div class="height-without-bar lg:h-full px-4">
  <div class="mx-auto flex h-full max-w-xl flex-col items-center justify-center text-center">
    <p class="text-sm font-semibold uppercase tracking-[0.12em] text-theme-muted">404</p>
    <h1 class="mt-3 text-3xl font-semibold leading-tight text-theme-base md:text-4xl">
      {{ 'search.no_results' | translate }}
    </h1>
    <p class="mt-3 text-sm text-theme-muted md:text-base">
      {{ 'search.try_different_term' | translate }}
    </p>
    <a routerLink="/" class="mt-8 rounded-full border border-theme-base px-6 py-3 text-sm font-semibold transition hover:bg-theme-base hover:text-white">
      {{ 'search_page.back' | translate }}
    </a>
  </div>
</div>

